import React, { useEffect, useState, useContext } from "react";
import { useTheme, alpha } from "@mui/material/styles";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";

import { SidebarContext } from "../Sidebar/SidebarProvider";
import TablaCompleta from "./TablaCompleta";
import { PedidosVentaApi } from "../../api/PedidosVenta/PedidosVentaApi";

const PedidosVenta = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { contentMargin } = useContext(SidebarContext);
  const { empresa: empresaParam } = useParams();
  const empresa = (empresaParam || "stage").toLowerCase();
  const pageGradient =
    theme.palette.mode === "dark"
      ? `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${alpha(theme.palette.primary.main, 0.08)} 100%)`
      : "linear-gradient(180deg, #f8fafc 0%, #eef6f8 45%, #f5f3ff 100%)";

  const onEmpresaChange = (nextEmpresa) => {
    const target =
      nextEmpresa === "stage"
        ? "/pedidosVenta"
        : `/pedidosVenta/${encodeURIComponent(nextEmpresa)}`;
    navigate(target);
  };

  const [year, setYear] = useState(dayjs().year());
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) navigate("/login");
    else {
      try {
        const decoded = jwtDecode(token);
        if (decoded.exp < Date.now() / 1000) {
          localStorage.removeItem("token");
          navigate("/login");
        }
      } catch {
        navigate("/login");
      }
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");
        const decoded = jwtDecode(token);
        const userEmail = decoded.email;
        const isAdmin = decoded.isAdmin;

        const detalle = await PedidosVentaApi.getPedidosComisiones(empresa, year);

        const filtered = isAdmin
          ? detalle
          : detalle.filter(
              (row) =>
                row.E_MAIL?.toLowerCase().trim() ===
                userEmail.toLowerCase().trim(),
            );

        setRows(filtered);
      } catch (err) {
        console.error("❌ Error PedidosVenta:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [year, empresa]);

  return (
    <Box
      sx={{
        height: "100dvh",
        maxHeight: "100dvh",
        boxSizing: "border-box",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        background: pageGradient,
        pt: { xs: 1, md: 1.25 },
        px: { xs: 1.25, sm: 2 },
        pr: { xs: 1.25, sm: 2, md: 3 },
        pb: { xs: 10, md: 2 },
        ...contentMargin,
        minWidth: 0,
        width: "100%",
      }}
    >
      <TablaCompleta
        rows={rows}
        loading={loading}
        theme={theme}
        year={year}
        setYear={setYear}
        empresa={empresa}
        onEmpresaChange={onEmpresaChange}
      />
    </Box>
  );
};

export default PedidosVenta;
